var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var ControlSettingComponent = /** @class */ (function (_super) {
    __extends(ControlSettingComponent, _super);
    function ControlSettingComponent(injector) {
        return _super.call(this, injector) || this;
    }
    Object.defineProperty(ControlSettingComponent.prototype, "useSecurity", {
        get: function () {
            return this._useSecurity;
        },
        set: function (v) {
            this.data.useSecurity = v;
            this._useSecurity = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlSettingComponent.prototype, "isRecordOperation", {
        get: function () {
            return this._isRecordOperation;
        },
        set: function (v) {
            if (v) {
                this.data.recordOperation.operationDescription = this._operationDescription;
            }
            else {
                delete this.data.recordOperation.operationDescription;
            }
            this.data.recordOperation.isRecordOperation = v;
            this._isRecordOperation = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlSettingComponent.prototype, "operationDescription", {
        get: function () {
            return this._operationDescription;
        },
        set: function (v) {
            this.data.recordOperation.operationDescription = v;
            this._operationDescription = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlSettingComponent.prototype, "enablePassword", {
        get: function () {
            return this._enablePassword;
        },
        set: function (v) {
            this.data.enablePassword = v;
            this._enablePassword = v;
        },
        enumerable: true,
        configurable: true
    });
    ControlSettingComponent.prototype.ngOnInit = function () {
        var data = this.data;
        this._useSecurity = data.useSecurity;
        this._isRecordOperation = data.recordOperation.isRecordOperation;
        this._operationDescription = data.recordOperation.operationDescription;
        this._enablePassword = data.enablePassword;
    };
    ControlSettingComponent.prototype.save = function (editedComponent, hasAccessPermission) {
        if (hasAccessPermission) {
            this.saveComponentProperty(editedComponent, 'useSecurity', this.data.useSecurity);
            this.saveComponentProperty(editedComponent, 'isRecordOperation', this.data.recordOperation.isRecordOperation);
            if (this.data.recordOperation.isRecordOperation) {
                this.saveComponentProperty(editedComponent, 'operationDescription', this.data.recordOperation.operationDescription);
            }
            else {
                this.deleteComponentProperty(editedComponent, 'operationDescription');
            }
            this.saveComponentProperty(editedComponent, 'enablePassword', this.data.enablePassword);
        }
        else {
            this.deleteComponentProperty(editedComponent, 'useSecurity');
            this.deleteComponentProperty(editedComponent, 'isAwaysEnable');
            this.deleteComponentProperty(editedComponent, 'enableItems');
            this.deleteComponentProperty(editedComponent, 'isRecordOperation');
            this.deleteComponentProperty(editedComponent, 'operationDescription');
            this.deleteComponentProperty(editedComponent, 'enablePassword');
        }
    };
    ControlSettingComponent.prototype.saveComponentProperty = function (editedComponent, property, value) {
        editedComponent.diagram.model.setDataProperty(editedComponent.data, property, value);
    };
    ControlSettingComponent.prototype.deleteComponentProperty = function (editedComponent, propertyName) {
        delete editedComponent.data[propertyName];
    };
    __decorate([
        Input()
    ], ControlSettingComponent.prototype, "data", void 0);
    ControlSettingComponent = __decorate([
        Component({
            selector: 'control-setting',
            styles: [".element-setting-base{ .inline-label { margin: 10px 0px 0px 10px; display: inline-block; } .border-group { // border: 1px solid #ddd; padding: 5px; margin-bottom: 0px; } .inline-selector { display: inline-block; margin: 5px 0px; } .inline-variable { display: inline-block; margin: 5px 0px; } .inline-input { display: inline-block; margin: 5px 0px; }     } .date-time-setting-modal { .modal-content { width: 600px; } .cursor-pointer{ cursor: pointer; } .recode-input{ width: calc(100% - 70px); border: 1px solid #d7dbe5;   padding:  5px 10px; } textarea.noResize { resize: none; } } .toggleViewSettingModal { .modal-content { width: 600px; } } .textSettingModal { .modal-content { width: 600px; } } "],
            template: "<div class=\"fe-modal-body element-setting-base\"> <div class=\"fe-option-head\"> {{lc('SecuritySetting')}} </div> <div class=\"fe-modal-content\"> <div class=\"fe-form-group\"> <div> <label> <input type=\"checkbox\" name=\"useSecurity\" [(ngModel)]=\"useSecurity\" /> <span>{{lc(\"ConfirmBeforeOperate\")}}</span> </label> </div> </div> <div class=\"fe-form-group clearfix\"> <div class=\"fe-option-head-transverse float-left\"> <label> <input type=\"checkbox\" name=\"isRecordOperation\" [(ngModel)]=\"isRecordOperation\" /> <span>{{lc(\"RecordOperation\")}}</span> </label> </div> <div *ngIf=\"isRecordOperation\" class=\"fe-option-body-transverse float-left\"> <label> {{lc(\"OperationDescription\")}}： </label> <input type=\"text\" name=\"OperationDescription\" #OperationDescription=\"ngModel\" class=\"recode-input\" style=\"width: calc(100% - 70px);\" [(ngModel)]=\"operationDescription\" maxlength=\"50\" /> <validation-messages [formCtrl]=\"OperationDescription\"></validation-messages> </div> </div> <div class=\"fe-form-group\"> <div> <label> <input type=\"checkbox\" name=\"enablePassword\" [(ngModel)]=\"enablePassword\" /> <span>{{lc(\"EnablePassword\")}}</span> </label> </div> </div> </div> "
        })
    ], ControlSettingComponent);
    return ControlSettingComponent;
}(ConfigureComponentBase));
export { ControlSettingComponent };
